<template>
    <div>
        <label class="vform-editor-label section">Url</label>
      <div class="w-100"/>
      <original-language-viewer
          v-if="!templateEditing && $store.getters.getSelectedFormLanguage !== 'Unknown'"
          :original-text="element.url.dix['Unknown']"
          class="mb-2 w-100"
      /> <div class="w-100"/>
      <div class="vform-label lighter white non-bold">{{ $store.getters.getSelectedFormLanguage }}</div>
        <div class="dflex">
            <div class="col-12 p-0">
                <input
                    :placeholder="element.url.dix['Unknown']"
                    class="mb-1 form-text v-form-label form-text-dark"
                    type="text"
                    v-model="url"
                    @keydown="$v.url.$touch"
                />
                <div class="form-error" v-if="$v.url.$error">
                    {{ $t("errors.mustBeAValidURL") }}
                </div>
            </div>
            <label class="vform-editor-label section">Text</label>
          <div class="w-100"/>
          <original-language-viewer
              v-if="!templateEditing && $store.getters.getSelectedFormLanguage !== 'Unknown'"
              :original-text="element.label.dix['Unknown']"
              class="mb-2 w-100"
          /> <div class="w-100"/>
          <div class="vform-label lighter white non-bold">{{ $store.getters.getSelectedFormLanguage }}</div>
            <div class="col-12 p-0">
                <input
                    :title="element.label.dix['Unknown']"
                    class="mb-1 form-text v-form-label form-text-dark"
                    type="text"
                    v-model="element.label.dix[$store.getters.getSelectedFormLanguage]"
                />
            </div>
        </div>
        <div class="dflex mt-3">
            <div class="col row">
                <label class="vform-editor-label section mt-0">Display As</label>
            </div>
            <div
                v-for="(displayOption, index) in displayOptions"
                :class="[
                    'vform-text-option',
                    displayOption === element.displayOption ? 'active' : '',
                    index === 0 ? 'left' : 'right'
                ]"
                :key="index"
                @click="setDisplayOption(displayOption)"
            >
                <p>{{ $t("vform." + displayOption) }}</p>
            </div>
        </div>
        <label class="vform-editor-label section">Height</label>
        <label class="section ml-2 vform-editor-body slider-label"
            >{{  this.height ? `${this.height}%` : 'AUTO' }}</label
        >
        <slider :default-value="null" :initial-value="height"
              :interval="10" :max="100" :min="0"
              @change="(val) => { this.$set(this, 'height', val) }"></slider>
        <label class="vform-editor-label section">Options</label>
        <div class="col row dflex">
            <div class="col-12 pl-0 dflex">
                <label
                    class="container vform-editor-body"
                    :for="'chkEmphasized' + $vnode.key"
                    >{{ $t("emphasized") }}
                    <input
                        type="checkbox"
                        :id="'chkEmphasized' + $vnode.key"
                        v-model="element.emphasized"
                    />
                    <span class="checkmark"></span>
                </label>
            </div>
            <div class="col-12 pl-0 dflex">
                <label
                    class="container vform-editor-body"
                    :for="'chkOpenInNewTab' + $vnode.key + 1"
                    >{{ $t("vform.newTab") }}
                    <input
                        type="checkbox"
                        :id="'chkOpenInNewTab' + $vnode.key + 1"
                        v-model="element.openInNewTab"
                    />
                    <span class="checkmark"></span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import { vFormControls, placeholders } from "@/enum";
import vFormElementMixin from "@/components/vForm/vFormElementMixin.js";
import { url } from "vuelidate/lib/validators";
import "vue-slider-component/theme/default.css";
import Slider from "@/components/widgets/editors/Slider";
import OriginalLanguageViewer from "@/components/vForm/OriginalLanguageViewer.vue";

export default {
    name: "vFormWEBSITE",
    components: {
      OriginalLanguageViewer,
        Slider
    },
    props: {
        element: { type: Object, required: true },
        stepNo: { type: Number, required: true },
        organizationId: { type: String, default: "" },
    },
    mixins: [vFormElementMixin],
    data() {
        return {
            forceReRenderKey: 0,
            vFormControls: vFormControls,
            placeholders: placeholders,
            url: "",
            height: 0,
            displayOptions: ["link", "iframe"],
        };
    },
    beforeMount() {
        if (!this.element.url) {
            this.$set(this.element, "url", {
                dix: {
                    Unknown: "",
                },
            });
        }

        this.element.formElementType = vFormControls["WEBSITE"];
        this.height = this.element.height ? this.element.height : this.height;
        this.url = this.element.url.dix[this.$store.getters.getSelectedFormLanguage];
        this.element.backgroundColor = this.element.backgroundColor
            ? this.element.backgroundColor
            : false;

        if (!this.element.displayOption) {
            this.$set(this.element, "displayOption", "link");
        }

        this.element.openInNewTab =
            this.element.openInNewTab === undefined ? true : this.element.openInNewTab;
    },
    watch: {
    element: {
      handler(newEl) {
        if (!newEl.url) {
          this.$set(newEl, "url", { dix: { Unknown: "" } });
        }
        this.height = newEl.height || 0;
        this.url = newEl.url.dix[this.$store.getters.getSelectedFormLanguage] || "";
      },
    },
        url() {
            this.element.url.dix[this.$store.getters.getSelectedFormLanguage] = this.url;
        },
        height() {
            this.$set(this.element, "height", this.height);
        },
    },
    validations: {
        url: {
            url,
        },
    },
    methods: {
        setDisplayOption(val) {
            this.$set(this.element, "displayOption", val);
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
